module.exports = __webpack_public_path__ + "img/banner.5f83fa46.jpg";